export const MakeConnectForYouConstants = {
    HEADER: "Make Connect Work For You",
    SAVE: "Save",
    CANCEL: "Cancel",
    ITEM_REQUIRED: "Required field missing.",
    VIEW_ANSWER: "Click to view Answer",
    TOPIC: "Topic: ",
    QUESTION: "Question: ",
    ANSWER: "Answer: ",
    NEW_TOPIC: "New Topic",
    NEW_QUESTION: "New Question",
    NEW_ANSWER: "Add your Answer here",
    DELETE_HEADER: "Delete",
    DELETE_TOPIC: "Are you sure to Delete the Topic ?",
    DELETE_ARTICLE: "Are you sure to Delete the Article ?",
    ARTICLE: "Article",
    TOPICS: "Topic",
    ERROR_LOADING: "Could not load FAQs. Please try after some time.",
    LAST_QUESTION_VALIDATION: "Minimum of 1 question is required per Topic",
};

export const WelcomeConstants = {
    WELCOME_HEADER: "Welcome to Connect",
    GET_STARTED: "Take a Tour",
    SHARE_FEEDBACK: "Share Feedback",
    ERROR_LOADING: "Could not fetch the Videos. Please try after some time.",
    NO_VIDEOS: "No Videos Added",
};

export const ReleaseNotesConstants = {
    RECENTLY_RELEASED: 'Recently Released',
    COMING_SOON: 'Coming Soon',
};

export const ManageVideosConstants = {
    CLOSE: "close",
    CONTENT_EDITOR_PORTAL: "Content Editor Portal",
    WELCOME_TO_CONNECT: "Welcome to Connect",
    filesAndMedia: {
        SAVE: "Save",
        DELETE: "Delete",
        UPDATE: "Update",
        REORDER: "Reorder",
        DATA_SAVE_CONF_MESSAGE: "Would you like to save your changes ?",
        DATA_REORDER_CONF_MESSAGE: "Would you like to save your reorder changes ?",
        LINK_COPIED_MESSAGE: "Link Copied",
        COPYLINK_TOOLTIP: "Copy Link",
        SHARELINK_TOOLTIP: "Share Link",
        ADD_FILE_TOOLTIP: "Add a File",
        newfolder: {
            id: 0,
            parentId: null,
            name: "New Folder",
            order: 1,
            fixed: false,
            isFolder: true,
            fileSubType: "folder",
            createdDate: "",
            fileSize: "0 kb",
            isEditRow: false,
            isNewRow: true,
            isDeleteRow: false,
        },
        FILETYPES_SUPPORTED: [".mp4"],
        FILE_NOT_SUPPORTED: "Invalid file type : only .mp4 file types allowed",
        FILE_NAME_LENGTH_EXCEEDED: "Filename length exceeded max character limit(30)",
        FILENAME_ALREADY_EXISTS: "File name already exists",
        FOlDERNAME_ALREADY_EXISTS: "Folder name  already exists",
        ERROR_MESSAGE_TIMEOUT_SECONDS: "3000",
        UPLOADING: "Uploading",
        BROWSE: "Browse or drag files here to add",
        DRAG_FILES_HERE: "DRAG FILES HERE TO ADD",
        TITLE: "Files and Media",
        PLEASE_ENTER_FOLDER_NAME: "Please Enter Folder Name",
        FIELD_SHOULD_NOT_BE_EMPTY: "Field should not be empty",
        actions: {
            ADD_FOLDER: "Add a Folder",
        },
        NO_MEDIA: "No videos added",
        tableColumns: {
            TYPE: { key: "TYPE", value: "type" },
            NAME: { key: "NAME", value: "title" },
            MODIFIED_BY: { key: "MODIFIED BY", value: "updatedUser" },
            LAST_MODIFIED: { key: "LAST MODIFIED DATE", value: "lastModifiedDateTime" },
        },
    },
};
export const FeedbackConstants = {
    SHARE_YOUR_FEEDBACK: "Share Your Feedback",
    THANKYOU: "Thank You!",
    FEEDBACK_ERROR: "Feedback Message Required",
    FEEDBACK_LENGTH_ERROR: "Feedback message must be or less than 1000 characters",
    QUESTION_ERROR: "Please Enter Question",
    QUESTION_LENGTH_ERROR: "Question length must be 150 characters",
    IMAGE_NAME_LENGTH_ERROR: "Image name should be less than 30 characters",
    NO_OF_FILES_ERROR: "6 files only allowed",
    QUESTION_TYPES: {
        TEXT_MESSAGE: "message",
        RATING: "rating",
        VOTE: "vote",
    },
    VOTING_TYPE: {
        THUMBS_UP: "thumbsUp",
        THUMBS_DOWN: "thumbsDown",
    },
    THANKYOU_DESCRIPTION:
        "On behalf of the entire YPO Management Organization, <br/> thank you. We appreciate your time and will incorporate your <br/>valuable feedback into planning future Connect enhancements.",
};
export const GetterConstants = {
    RECENT_RELEASES: "RecentReleases",
    COMING_SOON: "ComingSoon",
};

const commonFileTypeStrings = {
    videoFileTypes: ["video", "mp4"],
};

export const iconClassNames = (filetype) => {
    const fileTypes = commonFileTypeStrings;
    let iconClass = "";
    if (new RegExp(fileTypes.videoFileTypes.join("|")).test(filetype)) {
        iconClass = "fas fa-file-video";
    }
    return iconClass;
};
